export const lostWeight = [
  { label: '1-5 kg', value: 'ONE_TO_FIVE' },
  { label: '6-10 kg', value: 'SIX_TO_TEN' },
  { label: '11-15 kg', value: 'ELEVEN_TO_FIFTEEN' },
  { label: '>15 kg', value: 'MORE_THEN_FIFTEEN' },
  { label: 'Não sei', value: 'DONT_KNOW' }
]
